import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  POST_USERS_UPDATE_PASSWORD_REQUEST,
  POST_USERS_UPDATE_PASSWORD_SUCCESS,
  POST_USERS_UPDATE_PASSWORD_FAILURE,
  GET_PASSWORD_SECURITY_QUESTION_REQUEST,
  GET_PASSWORD_SECURITY_QUESTION_SUCCESS,
  GET_PASSWORD_SECURITY_QUESTION_FAILURE,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
import * as messages from "../../constants/Messages";
import { formatErrorMessage } from "../../utils/utils";
import { HTTP_400_BAD_REQUEST_CODE } from "../../constants/HttpStatusCode";

const initialState = {
  resetting: false,
  isGettingSecurityQuestion: false,
  security_question: null,
  error: {},
  message: "",
  errorMessage: "",
  shortMessage: "",
};

const processError = (err) => {
  let res = {};
  if (err && err.hasOwnProperty("data")) {
    for (let key in err.data.message) {
      if (Array.isArray(err.data.message[key])) {
        res[key] = err.data.message[key].join(",");
      } else if (typeof err.data.message[key] === "string") {
        res[key] = err.data.message;
      }
    }
  }

  return res;
};

export default (state = initialState, action) => {
  state = {
    ...state,
    message: "",
    errorMessage: "",
    shortMessage: "",
    error: {},
  };

  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
    case POST_USERS_UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        resetting: true,
      };

    case RESET_PASSWORD_SUCCESS:
    case POST_USERS_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        resetting: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case RESET_PASSWORD_FAILURE:
      if (action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        return {
          ...state,
          resetting: false,
          error: processError(action.payload.error),
        };
      } else {
        return {
          ...state,
          resetting: false,
          errorMessage: formatErrorMessage(
            action.payload.error.data.message,
            errMessages.ERR_SAVE_FAILURE
          ),
        };
      }
    case POST_USERS_UPDATE_PASSWORD_FAILURE:
      if (action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        return {
          ...state,
          resetting: false,
          error: processError(action.payload.error),
          errorMessage: errMessages.ERR_SAVE_FAILURE,
        };
      } else {
        return {
          ...state,
          resetting: false,
          errorMessage: formatErrorMessage(
            action.payload.error.data.message,
            errMessages.ERR_SAVE_FAILURE
          ),
        };
      }
    case GET_PASSWORD_SECURITY_QUESTION_REQUEST:
      return {
        ...state,
        isGettingSecurityQuestion: true,
      };
    case GET_PASSWORD_SECURITY_QUESTION_SUCCESS:
      return {
        ...state,
        isGettingSecurityQuestion: false,
        security_question: action.payload.security_question,
      };
    case GET_PASSWORD_SECURITY_QUESTION_FAILURE:
      if (action.payload.error && action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        return {
          ...state,
          isGettingSecurityQuestion: false,
          error: processError(action.payload.error),
        };
      } else {
        return {
          ...state,
          isGettingSecurityQuestion: false,
          error: action.payload.error,
          errorMessage: formatErrorMessage(
            action.payload.error.data.message,
            ""
          ),
        };
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/resetPassword.js